(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('main img, .shopify-section img');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    el.classList.add('scroll-reveal');
    var rect = el.getBoundingClientRect();
    var elCenter = rect.left + rect.width / 2;
    if (elCenter > window.innerWidth / 2) {
      el.classList.add('scroll-reveal--from-right');
    }
    observer.observe(el);
  });
})();
